import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { Hero } from 'shared/layout/Hero'
import { Heading } from 'ui/typography'
import { Container } from 'shared/layout/Container'
import { Box } from 'ui/primitives'
import { RichTextArea } from 'experiences/shared/RichTextArea'

export const CreditAuthorizationAgreement = () => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<>
			<Hero>
				<Heading.H1>{ResourceUtils(pageResources['credit_authorization.title']).getPlainTextContent()}</Heading.H1>
			</Hero>
			<Container>
				<Box paddingY="xxl">
					<RichTextArea document={ResourceUtils(pageResources['credit_authorization.content']).getRichContent()} />
				</Box>
			</Container>
		</>
	)
}
